import Head from "next/head";
import Footer from "pages/components/HummingFooter";
import Topbar from "pages/components/Topbar";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import StartHumming from "pages/components/StartHumming";
import FAQ from "./components/FAQ";
import PricingModule from "./components/Pricing";

import Heading from "./components/Heading";
import WhatMembersSay from "./components/WhatMembersSay";

import styles from "./styles.module.scss";
import WhyHH from "./components/WhyHH";

const Pricing: ExtendedNextPage = () => {
  return (
    <div className={styles.container}>
      <Head>
        <title>Pricing | Humming Homes</title>
        <meta
          name="description"
          content="Pricing starts at $250 per month, for your Humming Homes subscription."
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/pricing" />
      </Head>
      <Heading />
      <WhatMembersSay />
      <PricingModule />
      <WhyHH />
      <FAQ />
      <StartHumming />
    </div>
  );
};

Pricing.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default Pricing;
